import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import { showToast } from "../../utils/utils";
import "./accountingSoftware.scss";
import {
  NAME_REGEX_OPTIONAL,
  showToastType,
  TRUE
} from "../../utils/constants/appConstants";
import {
  createAccPage,
  editAccPage,
  accSoftwarePage,
  buttonName,
  monthlyCommison,
  alertActions,
  myAccount,
  commonValidationMsg
} from "../../locales/en";
import { FILE_SIZE_LIMIT } from "../../utils/constants/appConstants";
import { useDispatch, useSelector } from "react-redux";
import { accountsoftwareEditThunk } from "../../redux/accountingSoftwareSlice";
import privateAxios from "../../utils/axiosPrivate";
import { getaccountSoftwareEditURL } from "../../utils/constants/apiEndPoints";
import { sanitizeInput } from "../../utils/utils";
import { getActiveStatusOptions } from "../../utils/getDropdownOptions";
import { ACCOUNTING_SOFTWARES } from "../../route/paths";

const EditAccountingSoftware = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.accountingSoftware);

  const [iconFileName, setIcoFileName] = useState("");
  const [iconFile, setIconFile] = useState(null);
  const [nameError, setNameError] = useState("");
  const initialAccSoftware = {
    name: "",
    apiBaseUrl: "",
    authMethod: "",
    documentationUrl: "",
    iconUrl: "",
    isSupported: TRUE
  };
  const [accSoftware, setAccSoftware] = useState(initialAccSoftware);

  const fetchAccSoftware = async () => {
    try {
      const response = await dispatch(accountsoftwareEditThunk(id)).unwrap();
      const softwareData = response.data.data;

      setAccSoftware(softwareData);

      const iconPath = softwareData.iconUrl;
      const fileName = iconPath ? iconPath.split("/").pop() : "";

      setIcoFileName(fileName);
    } catch (error) {
      console.error(monthlyCommison.filter.errData, error);
    }
  };

  useEffect(() => {
    fetchAccSoftware();
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setAccSoftware((prevState) => ({
      ...prevState,
      [name]: sanitizeInput(value)
    }));
  };

  const handleFileChange = async (event) => {
    const { files } = event.target;

    // Ensure a file is selected
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];

    if (file.size > FILE_SIZE_LIMIT) {
      showToast(commonValidationMsg?.fileLimitError, showToastType.error);
      event.target.value = "";
      setIcoFileName("");
      return;
    }

    // Check file type
    const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
    if (!allowedTypes.includes(file.type)) {
      showToast(createAccPage?.errMsg.item2, showToastType.error);
      event.target.value = "";
      return;
    }

    setIcoFileName(file.name);

    setAccSoftware((prevState) => ({
      ...prevState,
      iconUrl: file.name
    }));

    setIconFile({ file, name: file.name, date: new Date().toISOString() });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const isValidName = NAME_REGEX_OPTIONAL.test(accSoftware.name);

      if (!accSoftware.name) {
        setNameError(createAccPage?.errMsg.item3);
        return;
      } else if (!isValidName) {
        setNameError(createAccPage?.errMsg.item4);
        return;
      } else {
        setNameError("");
      }

      const formDataToSend = new FormData();

      const accountinData = {
        name: sanitizeInput(accSoftware.name),
        apiBaseUrl: sanitizeInput(accSoftware.apiBaseUrl),
        authMethod: sanitizeInput(accSoftware.authMethod),
        documentationUrl: sanitizeInput(accSoftware.documentationUrl),
        isSupported: sanitizeInput(accSoftware.isSupported)
      };

      const accountingDataBlob = new Blob([JSON.stringify(accountinData)], {
        type: "application/json"
      });
      formDataToSend.append("accountingSoftwareDto", accountingDataBlob);

      if (iconFile && iconFile.file) {
        formDataToSend.append(
          "iconFile",
          iconFile.file,
          iconFile.name || "logo.jpeg"
        );
      }

      const config = {
        method: "put",
        url: getaccountSoftwareEditURL(id),
        headers: { "Content-Type": "multipart/form-data" },
        data: formDataToSend
      };

      const response = await privateAxios(config);

      showToast(response.data.message, showToastType.success);

      navigate(ACCOUNTING_SOFTWARES);
    } catch (error) {
      if (error.response) {
        showToast(error.response.data.message, showToastType.error);
      }
    }
  };

  const handleCancel = () => {
    navigate(ACCOUNTING_SOFTWARES);
  };

  if (loading) {
    return (
      <div className="spinner-wrap bg-light">
        <div className="spinner-border custom-spinner-color" />
      </div>
    );
  }

  return (
    <>
      <TablePagesTitle mainTitle={myAccount?.tabNames.accSoftware} />
      <AccessPageAction
        subheading={editAccPage?.subheading}
        alluser={ACCOUNTING_SOFTWARES}
        allUserTitle={myAccount?.tabNames.accSoftware}
        createuser="/admin/accounting-softwares/create"
        createUserTitle={accSoftwarePage?.createBtn}
      />
      <div className="row mb-3 mx-0">
        <div className="col-md-12 sale-leade-form mt-3">
          <form onSubmit={handleSubmit}>
            <div className="row mb-2">
              <div className="col-sm-4 col-xl-2">
                <div className="input-title">
                  <label htmlFor="software">
                    {createAccPage?.softwareName}
                  </label>
                </div>
              </div>
              <div className="col-sm-8 col-xl-10">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Accounting Software Name"
                    name="name"
                    value={accSoftware.name}
                    onChange={handleInputChange}
                  />
                  {nameError && (
                    <div className="text-danger small">{nameError}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4 col-xl-2">
                <div className="input-title">
                  <label htmlFor="apiBase">{createAccPage?.apiBase}</label>
                </div>
              </div>
              <div className="col-sm-8 col-xl-10">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="API Base Url"
                    name="apiBaseUrl"
                    value={accSoftware.apiBaseUrl}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4 col-xl-2">
                <div className="input-title">
                  <label htmlFor="authMethod">
                    {createAccPage?.authMethod}
                  </label>
                </div>
              </div>
              <div className="col-sm-8 col-xl-10">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Auth Method"
                    name="authMethod"
                    value={accSoftware.authMethod}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4 col-xl-2">
                <div className="input-title">
                  <label htmlFor="documentUrl">
                    {createAccPage?.documentUrl}
                  </label>
                </div>
              </div>
              <div className="col-sm-8 col-xl-10">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Documentation Url"
                    name="documentationUrl"
                    value={accSoftware.documentationUrl}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-4 col-xl-2">
                <div className="input-title">
                  <label htmlFor="icon">{createAccPage?.icon}</label>
                </div>
              </div>
              <div className="col-sm-8 col-xl-10">
                <div className="input-group">
                  <input
                    type="file"
                    name="iconFile"
                    onChange={handleFileChange}
                  />
                  {iconFileName && (
                    <p className="file-name mt-1">
                      {createAccPage?.selectedFile} {iconFileName}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-sm-4 col-xl-2">
                <div className="input-title">
                  <label htmlFor="status">{createAccPage?.status}</label>
                </div>
              </div>
              <div className="col-sm-8 col-xl-10">
                <div className="input-group">
                  <select
                    name="isSupported"
                    id="isSupported"
                    onChange={handleInputChange}
                    value={accSoftware.isSupported}
                  >
                    {getActiveStatusOptions().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-sm-8 offset-sm-2 d-flex d-sm-block justify-content-center justify-content-sm-start">
                <button
                  type="button"
                  className="btn btn-red me-2"
                  onClick={handleCancel}
                >
                  {alertActions?.Cancel}
                </button>
                <button type="submit" className="btn btn-primary">
                  {buttonName?.update}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditAccountingSoftware;
